/*
    3001・・・顧客・車両・履歴管理・・・SFCCM-127400
    3003・・・整備伝票作成業務・・・SFCMA-127100
    3005・・・顧客アプローチ業務(DM/メール)・・・SFCMA-127300
    4003・・・申請書類作成業務（認証）・・・SFCMA-122560
    4004・・・e-jibai連動・・・SFCMA-122570
    4010・・・コンタクトスケジュール・・・SFCCM-110410
    4012・・・整備工程管理・・・SFCMA-122300
    4013・・・スーパー検査員ｰ点検業務・・・SFCMA-122700
    4015・・・ピット予定管理・・・SFCMA-122450
    4016・・・メカニック作業予定管理・・・SFCMA-122400
    4017・・・接客提案（顧客カルテ・タブレット提案）・・・SFCCM-125400
    4021・・・鈑金伝票作成業務・・・SFCRP-100250
    4023・・・軽鈑金伝票作成業務・・・SFCRP-100280
    4026・・・来店通知（ナンバープレート認識）・・・SFCCM-125500
 */
interface RequiredOP {
  id: string,
  name: string,
  requiredOP: string[],
}

export const requiredOP01: RequiredOP = {
  id: "SFCMA-126400",
  name: "追加整備・交換部品提案",
  requiredOP: ["SFCCM-127400", "SFCMA-127100", "SFCMA-127300"]
}

const requiredOP02: RequiredOP = {
  id: "SFCCM-126300",
  name: "請求按分・担当者実績按分機能",
  requiredOP: ["SFCMA-127100"]
}

const requiredOP03: RequiredOP = {
  id: "SFCMA-122550",
  name: "申請書類作成業務（指定工場向け）",
  requiredOP: ["SFCMA-122560", "SFCMA-122570"]
}

const requiredOP04: RequiredOP = {
  id: "SFCMA-122700",
  name: "スーパー検査員ｰ点検業務",
  requiredOP: ["SFCMA-122300"]
}

const requiredOP05: RequiredOP = {
  id: "SFCMA-122800",
  name: "スーパー検査員ｰ検査員業務",
  requiredOP: ["SFCMA-122300", "SFCMA-122700"]
}

const requiredOP06: RequiredOP = {
  id: "SFCRP-101400",
  name: "鈑金工程管理",
  requiredOP: ["SFCRP-100250"]
}
/*
const requiredOP07: RequiredOP = {
  id: "4024",
  name: "CTI連携サービス（ローカルタイプ）",
  requiredOP: ["SFCCM-110410"]
}

const requiredOP08: RequiredOP = {
  id: "4025",
  name: "CTI連携サービス（クラウドタイプ）",
  requiredOP: ["SFCCM-110410"]
}
*/
const requiredOP09: RequiredOP = {
  id: "SFCCM-125500",
  name: "来店通知（ナンバープレート認識）",
  requiredOP: ["SFCCM-125400"]
}
/*
const requiredOP10: RequiredOP = {
  id: "SFCCM-126600",
  name: "`+スマホ来店通知(iPhone)",
  requiredOP: ["SFCCM-125400", "SFCCM-125500"]
}
*/
const requiredOP11: RequiredOP = {
  id: "SFCMA-122400",
  name: "メカニック作業実績集計",
  requiredOP: ["SFCMA-122450", "SFCMA-122400"]
}
/*
const requiredOP12: RequiredOP = {
  id: "4032",
  name: "POS連携サービス（ローカルタイプ）",
  requiredOP: ["SFCMA-127100"]
}

const requiredOP13: RequiredOP = {
  id: "4033",
  name: "POS連携サービス（クラウドタイプ）",
  requiredOP: ["SFCMA-127100"]
}
*/
const requiredOP14: RequiredOP = {
  id: "SFCMA-120000",
  name: "日整連作業点数",
  requiredOP: ["SFCMA-127100"]
}

const requiredOP15: RequiredOP = {
  id: "SFCMA-120100",
  name: "整備部品価格",
  requiredOP: ["30SFCMA-12710003"]
}

const requiredOP16: RequiredOP = {
  id: "SFCRP-101050",
  name: "自研センター指数（鈑金範囲）",
  requiredOP: ["SFCRP-100250"]
}

const requiredOP17: RequiredOP = {
  id: "SFCRP-101060",
  name: "輸入車指数データ",
  requiredOP: ["SFCRP-100250"]
}

const requiredOP18: RequiredOP = {
  id: "SFCRP-101200",
  name: "ボディ寸法図",
  requiredOP: ["SFCRP-100250"]
}

const requiredOP19: RequiredOP = {
  id: "SFCRP-101070",
  name: "自研センター指数（軽鈑金範囲）",
  requiredOP: ["SFCRP-100280"]
}

const requiredOP20: RequiredOP = {
  id: "SFCMA-122400",
  name: "メカニック作業予定管理",
  requiredOP: ["SFCMA-122300"]
}
const requiredOP21: RequiredOP = {
  id: "SFCMA-122450",
  name: "ピット予定管理",
  requiredOP: ["SFCMA-122300", "SFCMA-122400"]
}

export const REQUIRED_OP: RequiredOP[] = [
  requiredOP01,
  requiredOP02,
  requiredOP03,
  requiredOP04,
  requiredOP05,
  requiredOP06,
  //requiredOP07,
  //requiredOP08,
  requiredOP09,
  //requiredOP10,
  requiredOP11,
  //requiredOP12,
  //requiredOP13,
  requiredOP14,
  requiredOP15,
  requiredOP16,
  requiredOP17,
  requiredOP18,
  requiredOP19,
  requiredOP20,
  requiredOP21
]